import React, { useState } from "react";

import { useModal } from "@newsela/angelou";
import PropTypes from "prop-types";

import ScrollablePanel from "@/components/ScrollablePanel";
import SortableDeckOfCards from "@/assignments/AssignmentEditor/SortableDeckOfCards";
import ActivityCard from "../ActivityCard";
import ActivitySelectionModal from "../ActivitySelectionModal";
import EditStepButton from "../EditStepButton";
import {
  itemGridLayoutCss,
  activitiesStepCss,
  activitiesStepTitleCss,
} from "./StepItem.style";

const MoveDirections = { down: "DOWN", up: "UP" };

const propTypes = {
  /**
   * List of all available assignment activities
   */
  assignmentActivities: PropTypes.array,
  /**
   * Current assignment
   */
  assignment: PropTypes.object,
  /**
   * Number of the step,
   */
  index: PropTypes.number,
  /**
   * Function to fire when assignment step is deleted.
   */
  handleDeleteStep: PropTypes.func,
  /**
   * Function to fire when assignment is moved.
   */
  handleMoveStep: PropTypes.func,
  /**
   * Number of assignment steps.
   */
  stepsSize: PropTypes.number,
  /**
   * URL to show the content
   */
  contentViewUrl: PropTypes.string,
};

const StepItem = (props) => {
  const {
    index,
    assignmentActivities,
    assignment,
    handleDeleteStep,
    handleMoveStep,
    stepsSize,
    contentViewUrl,
  } = props;
  const [selectedActivities, setSelectedActivities] = useState([]);
  const [
    activitiesModalProps,
    activitiesModalSetActive,
    activitiesModalTriggerRef,
  ] = useModal(false);
  return (
    <div>
      <div css={activitiesStepCss}>
        <div css={activitiesStepTitleCss}>{`Step ${index + 1}`}</div>
        <EditStepButton
          isVisibleDeleteStep={stepsSize > 1}
          isVisibleMoveUp={stepsSize > 0 && index > 0}
          isVisibleMoveDown={stepsSize > 0 && index + 1 < stepsSize}
          onAddActivity={() => {
            activitiesModalSetActive(true);
          }}
          onDeleteStep={(e) => handleDeleteStep(e, assignment?.content_id)}
          onMoveStepUp={() =>
            handleMoveStep(MoveDirections.up, assignment?.content_id)
          }
          onMoveStepDown={() =>
            handleMoveStep(MoveDirections.down, assignment?.content_id)
          }
        />
      </div>
      <ScrollablePanel stepWidth={250}>
        <div css={itemGridLayoutCss}>
          <SortableDeckOfCards
            items={[assignment]}
            handleDeleteCard={handleDeleteStep}
          />
          {selectedActivities?.map((activity) => {
            return (
              <ActivityCard
                id={activity.id}
                key={activity.id}
                activity={activity}
                contentViewUrl={contentViewUrl}
              />
            );
          })}
          <SortableDeckOfCards.Item>
            <ActivitySelectionModal
              assignmentStep={index + 1}
              contentViewUrl={contentViewUrl}
              selectedStepActivities={selectedActivities}
              assignmentActivities={assignmentActivities}
              updateSelectedActivities={setSelectedActivities}
              activitiesModalProps={activitiesModalProps}
              activitiesModalSetActive={activitiesModalSetActive}
              activitiesModalTriggerRef={activitiesModalTriggerRef}
            />
          </SortableDeckOfCards.Item>
        </div>
      </ScrollablePanel>
    </div>
  );
};

StepItem.moveDirections = MoveDirections;
StepItem.propTypes = propTypes;
export default StepItem;
